import api from 'api';

import type { NextPageContext } from 'next';
import type { GetCompetenciesRes } from 'shared-types/responses';

interface GetCompetencyPageDataParams {
  competencyId: string;
  req?: NextPageContext['req'];
}

interface GetCompetencyPageDataResult {
  competency: GetCompetenciesRes['competencyObjs'][0];
  categories: GetCompetenciesRes['categories'];
}

const getCompetencyPageData = async ({
  competencyId,
  req
}: GetCompetencyPageDataParams): Promise<GetCompetencyPageDataResult | null> => {
  try {
    const headers = req ? { Cookie: req.headers.cookie } : {};
    const response = await api.get(`/admin/competencies?id=${competencyId}`, {
      headers
    });
    if (!response.data.competencyObjs || !response.data.competencyObjs.length) {
      const error = new Error() as Error & { response: { status: number } };
      error.response = { status: 404 };
      throw error;
    }
    return {
      competency: response.data.competencyObjs[0],
      categories: response.data.categories
    };
  } catch (error) {
    return null;
  }
};

export default getCompetencyPageData;
